<template>
    <div class="tell-me">
        <Banner title="联系我们"/>
        <div class="section">
            <div class="section-content">
                <div class="content-summary">
                    <div class="summary-left">
                        <p class="title">重庆佳渝测绘有限公司</p>
                        <p class="eTitle">CONTACT US</p>
                        <p class="stitle">如有任何问题请联系我们，我们24小时竭诚为您服</p>
                        <p class="content">
                            <i class="el-icon-phone"></i><span>023-65317892</span><span>13368072790</span>
                        </p> 
                        <p class="content">
                            <i class="el-icon-s-cooperation"></i>
                        </p>
                        <p class="content">
                            <i class="el-icon-s-home"></i><span>重庆市沙坪坝区融汇温泉1号楼7-13</span>
                        </p>
                    </div>
                    <div class="summary-right">
                        <Map/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Banner from '../components/Banner'
import Map from './Map'

export default {
    components:{
        Banner,
        Map
    },
}
</script>
<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.tell-me{
    width: 100%;
    height: 100%;
    background-color: #14679f;
    position: relative;
    overflow: hidden;
    .section{
        width: 100%;
        &-content {
            width: 1240px;
            margin: 0 auto;
            background-color: #fff;
            .content-summary{
                display: flex;
                justify-content: center;
                padding: 100px 0;
                .summary-left{
                    width: 500px;
                    .title{
                        font-size: 30px;
                        color: #e13834;
                        letter-spacing:8px
                    }
                    .eTitle{
                        font-size: 30px;
                        color: gray;
                        padding: 20px 0;
                    }
                    .stitle{
                        font-size: 16px;
                        color:gray;
                    }
                    .content{
                        font-size: 40px;
                        margin-top: 30px;
                        color: #e13834;
                        span{
                            margin-left: 30px;
                            font-size: 16px;
                            color: gray;
                        }
                    }
                }

                .summary-right{
                    width: 620px;
                    height: 500px;
                    // border: 1px solid red;
                }
            }
        }
    }
}
</style>